// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YMUUH","col":"styles_col__1eHTA","actions":"styles_actions__3MWU1","conflict":"styles_conflict__3Rijo"};